export const json = {
  "pages": [
    {
      "name": "page1",
      "title": "🐦‍🔥 Early Bird Access",
      "description": "Early birds gets 50% Discount of our (already honest) fees: \nhttps://ommi.shop/pricing\n",
      "elements": [
        {
          "type": "text",
          "name": "Brand",
          "title": "Your Brand",
          "description": "...or Full Name",
          "isRequired": true,
          "autocomplete": "name",
          "placeholder": "YourBrand™ / Mario Rossi"
        },
        {
          "type": "checkbox",
          "name": "Privacy",
          "title": "Privacy",
          "isRequired": true,
          "choices": [
            {
              "value": "terms",
              "text": "I have read the Privacy Policy at https://ommi.shop/privacy and consent to the processing of my data."
            }
          ]
        }
      ]
    },
    {
      "name": "page3",
      "elements": [
        {
          "type": "tagbox",
          "name": "Materials",
          "title": "Main Materials",
          "description": "min: 1 | max: 3",
          "isRequired": true,
          "choices": [
            {
              "value": "print",
              "text": "🖼️ Paper and 📜 Canvas"
            },
            {
              "value": "ceramic",
              "text": "🏺 Ceramics"
            },
            {
              "value": "wood",
              "text": "🪵 Wood"
            },
            {
              "value": "metal",
              "text": "🔨 Metals"
            },
            {
              "value": "stone",
              "text": "🗿 Stone"
            },
            {
              "value": "plastic",
              "text": "👾 Plastic and 💍 Composites"
            },
            {
              "value": "textile",
              "text": "🧶 Fabrics and👜 Leather"
            },
            {
              "value": "glass",
              "text": "🫙 Glass"
            },
            {
              "value": "engineering",
              "text": "🦾 Engineering"
            },
            {
              "value": "organic",
              "text": "🌱 Organic"
            }
          ],
          "showOtherItem": true,
          "otherText": "Other (specify)",
          "maxSelectedChoices": 3,
          "minSelectedChoices": 1,
          "placeholder": "Metals, Glass ...",
          "allowCustomChoices": true,
          "closeOnSelect": true
        }
      ]
    },
    {
      "name": "page2",
      "elements": [
        {
          "type": "dropdown",
          "name": "Contact Method",
          "title": "What’s the best way to reach you?",
          "choices": [
            {
              "value": "phone",
              "text": "Phone / Whatsapp / Chat"
            },
            {
              "value": "email",
              "text": "E-Mail"
            }
          ],
          "choicesOrder": "asc"
        },
        {
          "type": "text",
          "name": "Phone",
          "visible": false,
          "visibleIf": "{Contact Method} = 'phone'",
          "title": "Cellphone",
          "isRequired": true,
          "inputType": "tel",
          "autocomplete": "tel",
          "placeholder": "+39 1234567898"
        },
        {
          "type": "text",
          "name": "Email",
          "visible": false,
          "visibleIf": "{Contact Method} = 'email'",
          "title": "E-mail",
          "isRequired": true,
          "inputType": "email",
          "placeholder": "your-work@e-mail.com"
        }
      ]
    }
  ],
  "completeText": "Invia",
  "widthMode": "responsive",
  "headerView": "advanced"
}